// Adapter to map Star of Well-Being database keys to completion page labels
// Database keys are camelCase, completion labels are Title-Case with hyphens

const KEY_TO_LABEL_MAP: { [key: string]: string } = {
  spiritual: 'Spiritual',
  nutritional: 'Nutritional',
  physical: 'Physical',
  emotioPsychoRational: 'Emotio-Psycho-Rational',
  legendarial: 'Legendarial',
  religioTraditioCultural: 'Religio-Traditio-Cultural',
  financial: 'Financial',
  environmental: 'Environmental',
  socioRelational: 'Socio-Relational',
  occupational: 'Occupational'
};

/**
 * Adapts Star of Well-Being scores from database format to completion page format
 * @param dbScores - Object with camelCase keys from database (e.g., { emotioPsychoRational: 3, spiritual: 4 })
 * @returns Object with Title-Case labels compatible with completion page (e.g., { 'Emotio-Psycho-Rational': 3, 'Spiritual': 4 })
 */
export const adaptStarScoresForCompletion = (dbScores: { [key: string]: number }): { [key: string]: number } => {
  const adapted: { [key: string]: number } = {};

  Object.entries(dbScores).forEach(([dbKey, score]) => {
    const label = KEY_TO_LABEL_MAP[dbKey];
    if (label) {
      adapted[label] = score;
    } else {
      // Fallback: try to create a readable label from camelCase
      const fallbackLabel = dbKey
        .replace(/([A-Z])/g, ' $1') // Add space before capital letters
        .replace(/^./, str => str.toUpperCase()) // Capitalize first letter
        .trim();
      adapted[fallbackLabel] = score;
    }
  });

  return adapted;
};

/**
 * Validates that scores are within the expected range (1-4)
 * @param scores - Score object to validate
 * @returns True if all scores are valid (1-4), false otherwise
 */
export const validateStarScores = (scores: { [key: string]: number }): boolean => {
  return Object.values(scores).every(score => score >= 1 && score <= 4 && Number.isInteger(score));
};

// Ensure this file is treated as a module
export {};








